import React from 'react';
import CookieSettings from '../components/common/CookieSettings';

const CookieSettingsPage = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-8 text-center text-white">Manage Your Cookie Preferences</h1>
      
      <div className="max-w-3xl mx-auto mb-8 text-white">
        <p className="mb-4">
          On this page, you can update your cookie preferences for our website. We use different 
          types of cookies to optimise your experience on our site and to provide our services.
        </p>
        <p className="mb-4">
          You can modify your preferences at any time by selecting or deselecting the different 
          cookie categories below. Note that necessary cookies can't be disabled as they are essential 
          for the website to function properly.
        </p>
        <p className="mb-8">
          For more information about the cookies we use, please visit our 
          <a href="/cookie-policy" className="text-blue-400 hover:underline ml-1">Cookie Policy</a>.
        </p>
      </div>
      
      <CookieSettings />
    </div>
  );
};

export default CookieSettingsPage; 